import React, { useRef } from "react";
import UI from "@mile-meeting/mile-ui";
import { CloseButton, EmptyImage, ImageForm, ImageWrapper, RoomImageContainer } from "./RoomImageUpload.styles";

interface RoomImageUploadProps {
  image: string | File | undefined;
  onChange: (value: string | File | undefined) => void;
}

export const RoomImageUpload: React.FC<RoomImageUploadProps> = ({ image, onChange }) => {
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleFileUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    onChange(file);
  };

  const handleEmptyImageClick = () => {
    fileInputRef.current?.click();
  };

  const handleRemoveImage = () => {
    onChange(undefined);
  };

  return (
    <ImageForm>
      <UI.Typography type="label01" fontStyle="bold" color="var(--alias-color-label-alternative)">
        회의실 이미지
      </UI.Typography>
      {!image && (
        <EmptyImage onClick={handleEmptyImageClick}>
          <UI.Icon name="upload" color="var(--alias-color-label-neutral)" />
        </EmptyImage>
      )}
      {image && (
        <ImageWrapper>
          <RoomImageContainer
            src={typeof image === "object" ? URL.createObjectURL(image) : image}
            onClick={handleEmptyImageClick}
          />
          <CloseButton onClick={handleRemoveImage}>
            <UI.Icon name="x" color="var(--alias-color-label-normal)" size={16} />
          </CloseButton>
        </ImageWrapper>
      )}
      <input
        style={{ display: "none" }}
        type="file"
        id="file-input"
        onChange={(e) => handleFileUpload(e)}
        ref={fileInputRef}
      />
      <UI.Typography
        type="label02"
        fontStyle="regular"
        color="var(--alias-color-label-alternative)"
        style={{ textAlign: "center" }}
      >
        회의실을 대표하는 이미지를 업로드해주세요.
        <br />
        (최대 용량 2mb 제한, 1장 등록 가능)
      </UI.Typography>
    </ImageForm>
  );
};

export default React.memo(RoomImageUpload);
